// extracted by mini-css-extract-plugin
export var dividerContainer = "_94-0";
export var line = "_94-1";